import { render, staticRenderFns } from "./VaultAbout.vue?vue&type=template&id=68bf94ac&"
import script from "./VaultAbout.vue?vue&type=script&lang=js&"
export * from "./VaultAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports